import { AppConfig } from '../core-bundle/config/app-config';

import FormDataHelper from './helper/formdata';

import Pending from '@app/action/pending';
import Notification from '@app/action/notification';

import ActionHelper from '@module/redux-actions';

export default ActionHelper.generate({
  submit(params = {}) {
    const pendingId = 'contactSales';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      const url = new URL(AppConfig.salesforce.postLeadURL);

      // We're being redirected, so keep the pending state a bit longer.
      const template = {
        formdata: {
          action: url.href,
          enctype: 'application/x-www-form-urlencoded',
          method: 'POST',
        },
        form: params,
      };

      try {
        FormDataHelper.submit(template.formdata, template.form);
      } catch (error) {
        dispatch(Notification.setNotification('error', 'something_went_wrong'));
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },
});
